export default "__VITE_ASSET__DWVgbexS__"